var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1009,
    height: 266,
    viewBox: "0 0 1009 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5877 188.501C47.3577 188.501 36.7876 180.251 34.4576 164.811L34.2477 163.541H10.3477L10.5576 165.231C13.0976 195.051 36.5777 210.701 64.4977 210.701C80.2577 210.701 94.9777 205.081 103.068 193.411C91.7377 192.711 82.0376 190.491 73.5376 187.291C70.1176 188.151 66.3376 188.491 62.5976 188.491L62.5877 188.501Z",
    fill: "#1F7888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.539 171.15C109.539 159.09 102.559 149.58 93.6794 141.96C89.2394 137.94 84.3694 134.56 79.5094 131.39C74.6494 128.43 69.9894 125.68 65.7594 123.14C61.3194 120.39 57.0894 118.06 52.6494 115.74C50.5394 114.47 48.2094 113.2 46.0894 111.93C43.9794 110.45 41.8594 109.18 40.1694 107.49C36.9994 104.32 34.6694 100.51 34.6694 95.2205C34.6694 82.3205 48.6294 79.1505 60.2594 79.1505C62.5894 79.1505 67.0294 80.0005 69.3594 80.6305C80.7794 83.8005 86.6994 91.8405 87.7594 103.68V105.16H109.969L109.759 103.47C108.909 75.3405 86.9194 56.7305 59.8494 56.7305C36.3694 56.7305 10.3594 66.2505 10.3594 95.0105C10.3594 109.18 17.3394 118.7 26.8594 126.1C31.5094 129.7 36.5894 132.87 41.8794 135.83C47.1694 138.79 52.4594 141.54 57.3194 144.29C59.8594 145.77 63.0294 147.46 66.1994 149.37C69.3694 151.06 72.7594 153.18 75.7194 155.29C81.8494 159.94 86.2994 165.02 86.2994 171.15V172.43C93.0394 174.31 100.609 175.43 109.359 175.55C109.489 174.13 109.569 172.66 109.569 171.15H109.539Z",
    fill: "#1F7888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.94 166.291C149.3 164.601 147.609 159.311 147.609 157.831V111.511C147.609 108.341 149.089 103.051 150.359 99.8812C156.069 84.8612 168.97 78.3112 184.84 78.3112C200.71 78.3112 213.82 85.0812 219.53 100.101C220.8 103.271 222.07 108.141 222.07 111.521V117.371C229.34 114.901 236.99 113.311 245.12 112.581V111.521C245.12 104.961 243 96.9312 240.68 91.0012C230.74 66.6812 209.8 56.9512 184.84 56.9512C159.88 56.9512 138.519 66.4712 128.789 91.0012C126.459 97.1312 124.77 104.961 124.77 111.521V157.841C124.77 162.951 126.06 169.321 127.77 174.111C136.24 172.551 143.469 169.841 149.969 166.381C149.969 166.361 149.95 166.331 149.94 166.311V166.291Z",
    fill: "#1F7888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.066 157.83C222.066 160.37 220.376 165.87 219.526 168.62C213.396 184.27 201.546 191.89 184.836 191.89C174.356 191.89 165.786 188.31 159.386 181.86C158.716 182.23 158.066 182.61 157.376 182.97C150.696 186.43 143.696 189.02 136.316 190.79C147.366 205.72 164.646 212.4 184.836 212.4C211.276 212.4 232.006 200.98 241.516 175.39C243.206 170.52 245.116 163.12 245.116 157.83V130.75C236.306 131.71 228.776 133.85 222.066 136.79V157.83Z",
    fill: "#1F7888"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M366.528 154.651V59.8906H343.898V154.511C350.378 160.161 357.078 165.411 364.888 169.581C365.958 164.941 366.528 159.951 366.528 154.641V154.651Z",
    fill: "#1F7888"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M313.65 186.381C293.98 186.381 283.4 173.691 283.4 154.651V134.201C276.79 132.071 269.36 130.671 260.77 130.291V154.651C260.77 186.381 280.86 207.101 311.96 208.161H313.859C333.419 207.901 348.869 199.991 357.849 186.341C350.789 182.721 344.6 178.451 338.93 173.941C334 181.751 325.49 186.381 313.65 186.381Z",
    fill: "#1F7888"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M283.407 59.9004H260.777V112.18C269.137 112.5 276.617 113.64 283.407 115.38V59.9004Z",
    fill: "#1F7888"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M404.178 178.891V99.4406H404.388L440.968 171.211C447.148 168.251 452.658 164.621 457.878 160.621L406.928 59.8906H382.398V176.321C388.668 177.881 395.638 178.801 403.588 178.891C403.788 178.891 403.978 178.891 404.188 178.891H404.178Z",
    fill: "#1F7888"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M451.397 186.301C450.677 186.671 449.947 187.031 449.207 187.391L459.797 208.171H484.327V162.131C483.977 162.441 483.617 162.741 483.267 163.051C473.747 171.301 463.897 179.831 451.387 186.301H451.397Z",
    fill: "#1F7888"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M484.349 138.58V59.9004H462.559V156.92C465.549 154.47 468.479 151.93 471.439 149.37C475.609 145.76 479.859 142.1 484.349 138.58Z",
    fill: "#1F7888"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M382.398 194.871V208.161H404.188V196.981C403.918 196.981 403.658 196.981 403.388 196.981C395.718 196.891 388.768 196.141 382.398 194.861V194.871Z",
    fill: "#1F7888"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M524.739 118.21V80.8404H558.159C573.389 80.8404 583.959 89.3004 583.959 104.74V120.64C592.919 123.65 600.589 127.74 607.439 132.35V105.37C607.439 99.8704 605.959 93.1004 603.839 88.2404C595.379 67.5104 576.339 59.9004 555.619 59.9004H501.469V127.14C502.089 126.8 502.679 126.45 503.309 126.13C510.109 122.61 517.209 119.99 524.729 118.22L524.739 118.21Z",
    fill: "#1F7888"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M583.967 162.691C583.967 177.921 572.967 187.861 558.167 187.861H524.747V136.951C515.817 139.611 508.327 143.641 501.477 148.391V208.161H558.157C565.557 207.741 572.537 206.891 579.727 203.931C596.017 197.581 607.437 180.661 607.437 162.691V155.011C600.407 149.141 592.947 143.861 583.957 140.001V162.691H583.967Z",
    fill: "#1F7888"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M645.088 163.811V99.4506H645.938L686.338 175.381H693.108L732.658 99.4506H733.508V179.021C741.678 177.051 748.648 174.061 755.298 169.791V59.8906H730.978L689.948 137.511H689.318L647.648 59.8906H623.328V144.771C625.768 146.911 628.138 149.061 630.468 151.171C635.298 155.551 640.058 159.861 645.118 163.811H645.088Z",
    fill: "#1F7888"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M733.508 199.9V208.17H755.298V190.67C752.178 192.39 748.918 194.11 745.428 195.91C741.568 197.91 737.598 199.14 733.508 199.91V199.9Z",
    fill: "#1F7888"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M623.309 208.17H645.099V185.86C636.879 180.8 629.859 174.93 623.309 169.1V208.17Z",
    fill: "#1F7888"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M817.839 131.18L827.209 98.3904H828.27L836.699 128.38C839.529 128.21 842.409 128.13 845.359 128.17C850.469 128.23 855.26 128.58 859.78 129.19L839.05 59.9004H816.209L791.77 142.01C793.58 140.92 795.419 139.87 797.349 138.87C803.859 135.5 810.669 132.95 817.849 131.19L817.839 131.18Z",
    fill: "#1F7888"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M783.206 170.721L771.996 208.381H795.686L807.526 167.351H847.926L859.556 208.381H883.456L865.586 148.661C859.506 147.211 852.776 146.361 845.136 146.271C815.506 145.981 798.976 157.381 783.196 170.721H783.206Z",
    fill: "#1F7888"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M921.326 142.171H957.916C983.716 142.171 1001.49 127.371 1001.49 100.711V98.8106C1001.28 93.5206 1000.85 88.4506 998.526 83.3706C991.546 66.6606 971.666 59.8906 955.376 59.8906H899.746V143.951C907.846 149.191 914.796 155.191 921.316 161.071V142.171H921.326ZM921.326 80.2006H954.536C968.286 80.2006 979.286 86.3306 979.286 100.931C979.286 112.351 975.266 117.221 969.556 119.331C966.596 120.391 962.996 121.021 958.986 121.231H946.296C938.046 121.231 929.586 121.021 921.336 121.021V80.2006H921.326Z",
    fill: "#1F7888"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M899.748 166.34V208.16H921.318V185.33C918.208 182.66 915.228 179.96 912.308 177.31C908.148 173.54 904.038 169.82 899.738 166.33L899.748 166.34Z",
    fill: "#1F7888"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7188 28.8002L46.2588 9.99023H69.4187L80.0788 28.8002H103.169",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M102.227 28.8002L114.767 9.99023H137.937L148.587 28.8002H171.677",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M171.207 28.8002L183.747 9.99023H206.907L217.567 28.8002H240.647",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M240.648 28.8002L253.198 9.99023H276.358L287.008 28.8002H310.098",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M309.168 28.8002L321.708 9.99023H344.868L355.528 28.8002H378.608",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M378.137 28.8002L390.687 9.99023H413.847L424.497 28.8002H447.587",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M447.59 28.8002L460.13 9.99023H483.29L493.95 28.8002H517.03",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M516.098 28.8002L528.638 9.99023H551.808L562.458 28.8002H585.548",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M585.078 28.8002L597.618 9.99023H620.778L631.438 28.8002H654.518",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M654.52 28.8002L667.069 9.99023H690.229L700.88 28.8002H723.969",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M723.039 28.8002L735.579 9.99023H758.739L769.389 28.8002H792.479",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M792.008 28.8002L804.548 9.99023H827.718L838.368 28.8002H861.458",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M860.988 28.8002L873.528 9.99023H896.698L907.348 28.8002H930.438",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M929.969 28.8002L942.509 9.99023H965.669L976.329 28.8002H999.409",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8183 28.8008H9.73828",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7188 237.311L46.2588 256.121H69.4187L80.0788 237.311H103.169",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M102.227 237.311L114.767 256.121H137.937L148.587 237.311H171.677",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M171.207 237.311L183.747 256.121H206.907L217.567 237.311H240.647",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M240.648 237.311L253.198 256.121H276.358L287.008 237.311H310.098",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M309.168 237.311L321.708 256.121H344.868L355.528 237.311H378.608",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M378.137 237.311L390.687 256.121H413.847L424.497 237.311H447.587",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M447.59 237.311L460.13 256.121H483.29L493.95 237.311H517.03",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M516.098 237.311L528.638 256.121H551.808L562.458 237.311H585.548",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M585.078 237.311L597.618 256.121H620.778L631.438 237.311H654.518",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M654.52 237.311L667.069 256.121H690.229L700.88 237.311H723.969",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M723.039 237.311L735.579 256.121H758.739L769.389 237.311H792.479",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M792.008 237.311L804.548 256.121H827.718L838.368 237.311H861.458",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M860.988 237.311L873.528 256.121H896.698L907.348 237.311H930.438",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M929.969 237.311L942.509 256.121H965.669L976.329 237.311H999.409",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8183 237.311H9.73828",
    stroke: "#E97A69",
    strokeWidth: 18.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5136185528cc881eabb53c319d47d0eb.svg";
export { ForwardRef as ReactComponent };